<template>
  <div>
    <div class="progress-container">
      <div class="progress-info">
        <mtd-row>
          <mtd-col :span="24">
            <div style="font-size: 48px;color: rgba(10,112,245,1);text-align: center;height: 70px"
                 v-if="record.status === 0">
              <mtd-icon name='time'></mtd-icon>
            </div>
            <div style="font-size: 48px;color: #00B365;text-align: center;height: 70px" v-if="record.status === 1">
              <mtd-icon name='success-circle'></mtd-icon>
            </div>
            <div style="font-size: 48px;color: #f5483b;text-align: center;height: 70px" v-if="record.status === 2">
              <mtd-icon name='error-circle'></mtd-icon>
            </div>
          </mtd-col>
        </mtd-row>
        <mtd-row>
          <mtd-col :span="24" v-if="record.status === 0">
            <div class="progress-doing-tips">
              <span>{{ $getText('ws_mobile_approval_initiated_tips', '已经发起审批，如果长时间未反馈，可大象联系审批人进入审批详情页催办') }}</span>
            </div>
          </mtd-col>
          <mtd-col :span="24" v-if="record.status === 2">
            <div class="progress-success-tips">
              <span>{{ $getText('ws_mobile_approval_rejected', '审批已被驳回') }}</span>
            </div>
          </mtd-col>
          <mtd-col :span="24" v-if="record.status === 1">
            <div class="progress-success-tips">
              <span>{{ $getText('ws_mobile_approval_passed_tips', '审批已通过，可复制链接及提取码文本发送给用户') }}</span>
            </div>
            <div class="expire-tips-container" style="width: 100%;text-align: center;">
              <div class="expire-tips">
                <span v-if="record.outOfDate">
                  <i class='mtdicon-info-circle' style="margin-right: 4px;"/>
                  {{ $getText('ws_mobile_link_expired_tips', '链接已过期，请重新申请或续期') }}
                </span>
                <span v-else="record.outOfDate">
                  <i class='mtdicon-time' style="margin-right: 4px;"/>
                  {{ $getText('ws_mobile_link_created_expire_tips',
                  {createDate: record.createDate,
                  expireHours: record.expireHours},
                  '链接于{createDate}日创建，{expireHours}后过期') }}
                </span>
              </div>
            </div>
            <div class="out-link" style="margin-top: -18px">
              <div style="width: 80%;word-wrap: break-word">
                <mtd-form>
                  <mtd-form-item :label="$getText('ws_mobile_file_send_out_link_text', '文件外发链接：')" :label-width="110">
                    <a :href="record.downloadUrl" target="_blank">{{ record.downloadUrl }}</a>
                  </mtd-form-item>
                  <mtd-form-item :label="$getText('ws_mobile_extraction_code', '提取码')" :label-width="110">
                    {{ record.downloadPassword }}
                  </mtd-form-item>
                </mtd-form>
              </div>
              <div style="width: 20%;margin: auto;text-align: right">
                <mtd-button class="btn-demo-item" ghost type="primary" size="small" v-if="record.outOfDate"
                            @click="renew_record(record)">{{ $getText('ws_mobile_renew', '续期') }}
                </mtd-button>
                <mtd-button class="btn-demo-item" ghost type="primary" size="small" v-else="record.outOfDate"
                            v-clipboard:copy="outLinkAndPass" v-clipboard:success="onCopy" v-clipboard:error="onError">
                  {{ $getText('ws_mobile_copy', '复制') }}
                </mtd-button>
              </div>
            </div>
          </mtd-col>
        </mtd-row>
        <mtd-row>
          <mtd-col :span="24">
            <div class="progress-btn-container">
              <mtd-button class="btn-demo-item" type="primary" ghost size="large"
                          style="width: 164px;border-radius: 8px;font-size: 14px" @click="scanAgain"
                          :disabled="againDisabled">{{ $getText('ws_mobile_apply_again', '再次申请外发') }}
              </mtd-button>
              <mtd-button class="btn-demo-item" size="large"
                          style="width: 164px;float: right;border-radius: 8px;font-size: 14px" @click="goRecord">{{ $getText('ws_mobile_application_history', '申请历史') }}
              </mtd-button>
            </div>
          </mtd-col>
        </mtd-row>
      </div>
      <div class="apply-progress-expand" v-if="approvalList.length > 0">
        <div class="apply-progress-expand-title">
          <mtd-row type="flex" class="row-bg" justify="space-between">
            <mtd-col :span="6">
              <span class="div-title">{{ $getText('ws_mobile_approval_progress', '审批进度') }}</span>
            </mtd-col>
            <mtd-col :span="6" v-if="approvalExpand">
              <div style="float: right" @click="approvalExpand = !approvalExpand">
                <span class="div-icon">{{ $getText('ws_mobile_collapse', '收起') }}</span>
                <mtd-icon name='up-thick'></mtd-icon>
              </div>
            </mtd-col>
            <mtd-col :span="6" v-if="!approvalExpand">
              <div style="float: right" @click="approvalExpand = !approvalExpand">
                <span class="div-icon">{{ $getText('ws_mobile_expand', '展开') }}</span>
                <mtd-icon name='down-thick'></mtd-icon>
              </div>
            </mtd-col>
          </mtd-row>
        </div>
        <div class="approval-progress" v-if="approvalExpand">
          <mtd-steps :active="currentNode" direction="vertical" :space="70" size="small">
            <mtd-step :title="item.title" v-for="(item, index) in approvalList" :key="index"
                      :status="statusDefine(index)">
              <template slot="description">
                <div><img :src="item.img" class="approval-img">&nbsp;&nbsp;{{ item.mis }}</div>
              </template>
            </mtd-step>
          </mtd-steps>
        </div>
      </div>
      <div class="apply-detail-expand">
        <div class="apply-detail-expand-title">
          <mtd-row type="flex" class="row-bg" justify="space-between">
            <mtd-col :span="6">
              <span class="div-title">{{ $getText('ws_mobile_application_details', '申请详情') }}</span>
            </mtd-col>
            <mtd-col :span="6">
              <div style="float: right" v-if="applyDetailExpand">
                <span class="div-icon" @click="applyDetailExpand = !applyDetailExpand">{{ $getText('ws_mobile_collapse', '收起') }}</span>
                <mtd-icon name='up-thick'></mtd-icon>
              </div>
            </mtd-col>
            <mtd-col :span="6" v-if="!applyDetailExpand">
              <div style="float: right" @click="applyDetailExpand = !applyDetailExpand">
                <span class="div-icon">{{ $getText('ws_mobile_expand', '展开') }}</span>
                <mtd-icon name='down-thick'></mtd-icon>
              </div>
            </mtd-col>
          </mtd-row>
        </div>
        <div class="extra-info-detail" v-if="applyDetailExpand">
          <mtd-form>
            <mtd-form-item :label="$getText('ws_mobile_file_name', '文件名称')" :label-width="100">
              <div class="br-div">{{ record.fileName }}</div>
            </mtd-form-item>
            <mtd-form-item :label="$getText('ws_mobile_file_count', '文件数量')" :label-width="100">
              <div class="br-div">{{ $getText('ws_mobile_file_count_unit', {count: record.fileNum}, '{count}个文件') }}</div>
            </mtd-form-item>
            <mtd-form-item :label="$getText('ws_mobile_send_out_process', '外发流程')" :label-width="100">
              <div class="br-div">{{ record.strategyName || $getText('ws_mobile_no_approval_required', '免审批') }}</div>
            </mtd-form-item>
            <mtd-form-item :label="$getText('ws_mobile_send_out_reason', '外发原因')" :label-width="100">
              <div class="br-div">{{ record.reason ||  $getText('ws_mobile_none', '无') }}</div>
            </mtd-form-item>
            <mtd-form-item :label="$getText('ws_mobile_send_out_email', '外发邮箱')" :label-width="100">
              <div class="br-div">{{ record.emails || $getText('ws_mobile_none', '无') }}</div>
            </mtd-form-item>
          </mtd-form>
        </div>
      </div>
    </div>
    <!-- 选择有效期 -->
    <mtdm-slide-modal v-model="validate_days_modal" :title="$getText('ws_mobile_set_validity_period', '设置有效期')">
      <div class="validate_days_content">
        <mtd-radio-group v-model="renew_record_data.validateDays" @input="validateDays_change">
          <mtd-radio :value="3" @click="validateDays_click">3{{ $getText('ws_mobile_days', '天') }}</mtd-radio>
          <mtd-radio :value="7" @click="validateDays_click">7{{ $getText('ws_mobile_days', '天') }}</mtd-radio>
          <mtd-radio :value="30" @click="validateDays_click">30{{ $getText('ws_mobile_days', '天') }}</mtd-radio>
          <mtd-radio :value="-1">
            <span>{{ $getText('ws_mobile_custom_expiry_date', '自定义到期日') }}</span><br/>
            <span class="custom-tips">{{ $getText('ws_mobile_custom_expiry_tips', '可设定30天内任意日期') }}</span>
          </mtd-radio>
        </mtd-radio-group>
      </div>
    </mtdm-slide-modal>
    <!-- 自定义有效期 -->
    <mtdm-scrollpicker v-model="custom_validate_modal" :options="select_number" :value="custom_validate_days"
                       @cancel="close_custom_validate" @confirm="submit_custom_validate"
                       :confirm-text="$getText('ws_mobile_confirm', '确定')" nodeKey="value"/>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "mobile_file_out_progress",
  computed: {
    statusDefine() {
      return function (index) {
        if (index < this.currentNode) {
          return 'finish';
        } else if (index === this.currentNode) {
          if (this.status === 1) {
            return 'finish';
          } else if (this.status === 2 || this.status === 6) {
            return 'error';
          } else if (this.status === 3) {
            return 'process';
          }
        } else {
          return 'wait';
        }
      }
    },
    againDisabled() {
      return true;
    },
    select_number() {
      let result = []
      for (let i = 1; i <= 30; i++) {
        result.push({label: i, value: i});
      }
      return result;
    }
  },
  mounted() {
    // 修改标题
    document.title = this.$getText('ws_mobile_approval_details', '审批详情');

    let res = null;
    if (this.$route.params.record != null) {
      this.record = this.$route.params.record;
      res = this.$route.params.approvalList;
      this.keepAliveData = res;
      localStorage.clear();
      this.outLinkAndPass = this.$getText('ws_mobile_file_share_link_text', '文件分享链接：') + this.record.downloadUrl + '\n' + this.$getText('ws_mobile_file_share_password_text', '文件分享密码：') + this.record.downloadPassword;
    } else if (this.$route.query.id != null) {
      this.check_progress()
    } else {
      this.record = JSON.parse(localStorage.getItem("record"));
      res = JSON.parse(localStorage.getItem("approvalList"));
      this.keepAliveData = res;
      this.outLinkAndPass = this.$getText('ws_mobile_file_share_link_text', '文件分享链接：') + this.record.downloadUrl + '\n' + this.$getText('ws_mobile_file_share_password_text', '文件分享密码：') + this.record.downloadPassword;
    }
    if (res != null) {
      this.approvalList = res.list;
      this.currentNode = res.currentNode;
      this.status = res.status;
    }
  },
  data() {
    const validateCustomDays = (_rule, value, callback) => {
      if (!/^[0-9]*$/.test(value)) {
        return callback(new Error(this.$getText('ws_mobile_validity_range_error')));
      }
      if (value < 1 || value > 30) {
        return callback(new Error(this.$getText('ws_mobile_validity_range_error')));
      }
      return callback();
    };
    return {
      default_days: [
        {value: 3, label: '3' + this.$getText('ws_mobile_days')},
        {value: 7, label: '7' + this.$getText('ws_mobile_days')},
        {value: 30, label: '30' + this.$getText('ws_mobile_days')}
      ],
      record: {
        status: 3,
        emails: '',
        strategyName: '',
        reason: '',
        fileNum: 1,
        downloadUrl: '',
        downloadPassword: '',
        validateDays: 3,
      },
      approvalList: [],
      applyDetailExpand: false,
      approvalExpand: true,
      outLinkAndPass: '',
      currentNode: 0,
      status: 0,
      keepAliveData: {},
      renew_record_data: {
        id: null,
        validateDays: 3
      },
      validate_days_modal: false,
      custom_validate_days: [3],
      custom_validate_modal: false,
      custom_validate_rule: {
        custom_validate: [
          {validator: validateCustomDays, trigger: 'change'},
        ]
      },
    }
  },
  methods: {
    ...mapActions([
      'queryApprovalDetails',
      'submitRenewFileOutOrder'
    ]),
    onCopy() {
      this.$mtdm.toast({
        message: this.$getText('ws_mobile_copy_success', '复制成功'),
        icon: 'mtdmicon-success-circle',
        duration: 2000
      });
    },
    onError() {
      this.$mtdm.toast({
        message: this.$getText('ws_mobile_copy_failed', '复制失败'),
        icon: 'mtdmicon-error-circle',
        duration: 2000
      });
    },
    async check_progress(queryId) {
      let id = this.$route.query.id
      if (queryId) {
        id = queryId
      }
      await this.queryApprovalDetails({id}).then(response => {
        let res = null;
        if (response.code === 0) {
          this.record = response.data;
          res = response.approvalList;
          if (res != null) {
            this.approvalList = res.list;
            this.currentNode = res.currentNode;
            this.status = res.status;
          }
          this.outLinkAndPass = this.$getText('ws_mobile_file_share_link_text', '文件分享链接：') + this.record.downloadUrl + '\n' + this.$getText('ws_mobile_file_share_password_text', '文件分享密码：') + this.record.downloadPassword;
        } else {
          this.$mtdm.toast({
            message: this.$getText('ws_mobile_query_failed', '查询失败'),
            icon: 'mtdmicon-error-circle',
            duration: 2000
          });
        }
      });
    },
    scanAgain() {
      localStorage.setItem("approvalList", JSON.stringify(this.keepAliveData));
      localStorage.setItem("record", JSON.stringify(this.record));
      this.$router.push({
        name: 'mobile_file_outer_upload',
        query: {fileXmId: this.record.fileXmId, fileName: this.record.fileName, againFlag: true}
      });
    },
    goRecord() {
      localStorage.setItem("approvalList", JSON.stringify(this.keepAliveData));
      localStorage.setItem("record", JSON.stringify(this.record));
      this.$router.push({name: "mobile_file_outer_file_out_list"});
    },
    renew_record(row) {
      this.renew_record_data.id = row.id;
      this.validate_days_modal = true;
    },
    validateDays_change(val) {
      if (val === -1) {
        this.custom_validate_modal = true;
      } else {
        this.custom_validate_modal = false;
        this.validate_days_modal = false;
        // 提交
        this.submit_renew_recorde();
      }
    },
    validateDays_click(){
      if(this.renew_record_data.validateDays !== -1){
        this.custom_validate_modal = false;
        this.validate_days_modal = false;
        // 提交
        this.submit_renew_recorde();
      }
    },
    close_custom_validate() {
      this.custom_validate_modal = false;
      this.custom_validate_days = [3];
      this.renew_record_data.validateDays = 3;
    },
    submit_custom_validate(values) {
      if (values.length === 0) {
        return;
      }
      this.renew_record_data.validateDays = values[0];
      this.custom_validate_modal = false;
      this.validate_days_modal = false;
      this.custom_validate_days = [3];
      this.submit_renew_recorde();
    },
    submit_renew_recorde() {
      this.submitRenewFileOutOrder(this.renew_record_data).then(_res => {
        this.$mtdm.toast({
          message: this.$getText('ws_mobile_renew_success', '申请续期成功'),
          icon: 'mtdmicon-success-circle',
          duration: 2000
        });
        this.check_progress(this.renew_record_data.id);
      });
    }
  },
  destroyed() {
    console.log("执行了destroy方法");
    localStorage.setItem("approvalList", JSON.stringify(this.keepAliveData));
    localStorage.setItem("record", JSON.stringify(this.record));
  }
}
</script>

<style>
.progress-container {
  background-color: #f7f7f7;
  padding: 8px;
  min-height: 100vh;
}

.progress-info {
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding: 16px 8px;
}

.apply-detail-hidden, .apply-progress-hidden {
  margin-top: 8px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding: 16px;
  height: 54px;
}

.apply-detail-expand-title, .apply-progress-expand-title {
  margin-top: 8px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding: 16px;
  border-bottom: 1px #f7f7f7 solid;
}

.progress-doing-tips {
  font-family: PingFang SC, sans-serif;
  font-size: 13px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  font-weight: 400;
  line-height: 18px
}

.progress-btn-container {
  margin-top: 16px;
}

.apply-detail-expand, .apply-progress-expand {
  background-color: white;
  border-radius: 10px;
}

.expire-tips-container {
  background: rgba(245, 246, 247, 1);
  border-radius: 10px;
  width: 100%;
  text-align: center;
  margin-top: 16px;
  height: 32px;
  padding-top: 6px;
}

.expire-tips-container .expire-tips {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
  color: rgba(255, 95, 87, 1);
  text-align: center;
}

.out-link {
  display: flex;
  padding: 8px 16px;
  margin-top: 16px;
  background: rgba(245, 246, 247, 1);
  border-radius: 10px;
}

.extra-info-detail {
  padding: 8px;
}

.extra-info-detail .mtd-form-item-label, .out-link .mtd-form-item-label {
  text-align: left;
}

.extra-info-detail .mtd-form-item, .out-link .mtd-form-item {
  margin-bottom: 10px;
}

.approval-progress {
  background-color: white;
  padding: 16px 24px;
  border-radius: 10px;
}

.div-title {
  font-family: PingFang SC, sans-serif;
  font-size: 15px;
  color: rgba(51, 51, 51, 1);
  font-weight: 500;
  line-height: 21px
}

.div-icon {
  font-family: PingFang SC, sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  line-height: 22px;
  font-weight: 400;
}

.progress-success-tips {
  font-family: PingFang SC, sans-serif;
  font-size: 13px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  font-weight: 500;
  line-height: 18px
}

.demo-timeline-success {
  color: #5ABB3C;
  font-size: 20px;
  vertical-align: middle;
}

.demo-timeline-error {
  color: #FF6459;
  font-size: 20px;
  vertical-align: middle;
}

.demo-timeline-primary {
  color: #4E73FF;
  font-size: 20px;
  vertical-align: middle;
}

.approval-title {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 15px;
  color: rgba(51, 51, 51, 1);
  font-weight: 500;
  line-height: 21px;
  margin-bottom: 8px;
}

.approval-img {
  vertical-align: middle;
  width: 24px;
  height: 24px;
  border-radius: 100%;
}

.mtd-timeline-item-content-wrapper, .mtd-timeline-item-title {
  padding-bottom: 0px;
}

.mtd-step-finish .mtd-step-head-number {
  color: #00B365;
  border: 1px solid #00B365;
}

.mtd-steps-small.mtd-steps-vertical .mtd-step-main {
  top: -3px;
}

.br-div {
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}

.validate_days_content {
  padding: 14px 16px;
  height: 270px;
}

.validate_days_content .mtd-radio {
  display: block;
  width: 100%;
  height: 22px;
  margin-bottom: 28px;
}

.validate_days_content .mtd-radio .custom-tips {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.36);
  letter-spacing: 0;
  font-weight: 400;
  line-height: 17px;
  margin-left: 24px;
}

</style>
